import Main from 'modules/Services/Campaigns/Main/Main'
import Sagas from 'modules/Services/Campaigns/Main/saga'
import Reducer from 'modules/Services/Campaigns/Main/reducer'

export default Main

export {
  Sagas, Reducer
}
